<template>
  <div class="stream-group-uploading-row d-flex justify-between items-center">
    <button
      class="stream-group-detail-button d-flex justify-between items-center"
      @click="moveStreamGroupDetail(streamGroup.streamGroupId)"
    >
      <div class="stream-group-icon-wrapper">
        <img
          :src="require(`@/assets/images/${STREAM_GROUP_ICON}`)"
          alt="stream group icon"
          class="stream-group-icon"
        />
        <span class="badge">{{ streamGroup.contentCount }}</span>
      </div>
      <div class="stream-group-info">
        <div class="stream-group-title">
          {{ streamGroup.streamGroupName }}
        </div>
        <div class="stream-group-detail d-flex justify-between items-center">
          <div class="stream-group-duration">
            {{ convertSecToms(streamGroup.streamGroupDuration) }}
          </div>
          <div
            v-if="isStreamGroupUploadFailure(streamGroup.streamGroupUploadStatus)"
            class="stream-group-upload-failure"
          >
            登録に失敗しました
          </div>
        </div>
      </div>
    </button>
    <div class="not-streaming-button-area">
      <button :disabled="true" class="not-streaming-button">登録中</button>
    </div>
  </div>
</template>

<script setup>
import { STREAM_GROUP_UPLOAD_STATUS } from '@/composable/constant_common';
import { convertSecToms } from '@/composable/material_common';

defineProps({
  streamGroup: Object,
  moveStreamGroupDetail: Function,
});

// 配信グループボタンアイコン画像名
const STREAM_GROUP_ICON = 'StreamGroupButton.png';

/**
 * アップロード失敗判定処理
 *
 * @param streamGroupUploadStatus 配信グループ登録状態ステータス
 */
const isStreamGroupUploadFailure = (streamGroupUploadStatus) => {
  return [STREAM_GROUP_UPLOAD_STATUS.STREAM_GROUP_UPLOAD_ERR].includes(streamGroupUploadStatus);
};
</script>

<style scoped>
/** 配信グループ */
.stream-group-uploading-row {
  box-sizing: border-box;
  border-bottom: 0.1rem solid #ddd;
  width: 100%;
  position: relative;
  padding-block: 1rem;
}
.stream-group-uploading-row:first-child {
  border-top: 0.1rem solid #ddd;
}

/** 詳細情報エリア */
.stream-group-detail-button {
  background-color: white;
  border: none;
  flex-grow: 1;
}

/** 配信状態アイコン */
.stream-group-icon-wrapper {
  flex-shrink: 0;
  height: 4rem;
  width: 4rem;
  padding: 2rem;
  position: relative;
}
.stream-group-icon {
  height: 100%;
  width: 100%;
  object-fit: contain;
  filter: gray;
  -webkit-filter: grayscale(1);
}

/** コンテンツ数バッチアイコン */
.badge {
  text-align: center;
  background-color: rgba(170, 170, 170, 0.87);
  color: white;
  font-size: 1.1rem;
  padding: 0.3rem;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  position: absolute;
  right: 1.1rem;
  top: 1.5rem;
  z-index: 1;
}

/** 配信グループ情報表示エリア */
.stream-group-info {
  flex-grow: 1;
}
.stream-group-title {
  word-break: break-all;
  font-size: 1.6rem;
  margin-bottom: 1rem;
  text-align: left;
  color: #222222;
}
.stream-group-detail {
  font-size: 1.4rem;
}
.stream-group-duration {
  color: #aaaaaa;
}
.stream-group-upload-failure {
  color: #e63030;
}

/** 配信状態切り替えボタン */
.not-streaming-button-area {
  flex-shrink: 0;
  padding: 1.5rem;
}
.not-streaming-button {
  color: #9e9e9e;
  font-size: 1.4rem;
  padding: 0.5rem 1rem;
  background-color: white;
  border: 1px #cccccc solid;
  border-radius: 0.5rem;
}
</style>
